import { useEffect, useState } from 'react';
import { useScrollLock } from '../../../_Hooks/useScrollLock';
import { createPortal } from 'react-dom';
import { ConfirmBody } from './_ConfirmBody';
import { onSubscribeConfirm, onRequestConfirm } from './_confirmBus';

/*
    🔥 CONFIRM — propio, sin librería

    Portal + backdrop a mano. Cero dependencias: si mañana sale
    react-bootstrap del proyecto, este sigue andando.

    Hace lo que un diálogo modal debe hacer: bloquear el scroll,
    cerrar con Escape y no cerrarse por accidente al clickear adentro.
*/

export const ConfirmCustomHost = () => {

    const [useRequest, setRequest] = useState(null);

    useEffect(() => onSubscribeConfirm((payload) => setRequest(payload)), []);

    const onResolve = (value) => {
        useRequest?.resolve(value);
        setRequest(null);
    };

    /*
        🔥 Bloqueo del scroll mientras hay una confirmación abierta.

        ⚠️ Con el hook compartido, si el confirm sale desde adentro de un
           modal, cerrar el confirm ya no devuelve el scroll de la página.
    */
    useScrollLock(!!useRequest);

    useEffect(() => {

        if (!useRequest) return;

        const onEscape = (event) => {
            if (event.key !== 'Escape') return;
            useRequest.resolve(false);
            setRequest(null);
        };

        document.addEventListener('keydown', onEscape);

        return () => { document.removeEventListener('keydown', onEscape); };

    }, [useRequest]);

    if (!useRequest) return null;

    return createPortal(

        <div className="LStudio__app_confirm_backdrop" onClick={() => onResolve(false)}>

            <div className="LStudio__app_confirm_wrap" onClick={(event) => event.stopPropagation()}>
                <ConfirmBody {...useRequest.options}
                    onConfirm={(value) => onResolve(value)}
                    onCancel={() => onResolve(false)} />
            </div>

        </div>,

        document.body,
    );
};

export const onConfirmCustom = (options) => onRequestConfirm(options);
